<style lang="less">
    .colorListBox{
        background-color: #fff;
        width: 600px;
        position: fixed;
        left: 50%;
        top: 50%;
        // margin-top: -360px !important;
        transform: translateY(-50%);
        z-index: 4;
        margin-left: -300px !important;
        text-align: left;
        padding: 10px 20px 10px !important;
        border-radius: 8px;
        // height: 720px;
        .co_title{
            margin-bottom: 20px;
            font-size: 16px;
        }
        .colorListTableNav{
            display: flex;
            flex-wrap: wrap;
            >div{
                margin: 0 20px 20px 0;
                cursor: pointer;
                &.active{
                    color: #000;
                    font-size: 16px;
                    font-weight: bold;
                }
            }
        }
        .list{
            display: flex;
            flex-wrap: wrap;
            label{
                display: block;
                width: 112px;
                text-align: center;
                margin-bottom: 10px;
                /* margin-right: 30px; */
                p{
                    padding: 6px;
                    cursor: pointer;
                    margin-bottom: 0;
                }
                img{
                    width: 50px;
                    height: 50px;
                    cursor: pointer;
                    border-radius: 4px;
                }
            }
        }
        .next_pre{
            margin-top: 10px;
            display: flex;
            justify-content: flex-end;
        }
        .co_btn{
            width: 100%;
            // position: absolute;
            bottom: 0;
            right: 0;
            padding: 20px;
            display: flex;
            justify-content: space-between;
            // justify-content: flex-end;
            align-items: center;
            p{
                color: #999;
                font-size: 16px;
                margin-bottom: 0;
            }
            
        }
    }
</style>
<template>
    <div class="colorListBox">
        <p class="co_title">选择颜色</p>
        <!-- <div class="colorListTableNav">
            <div :class="colorTableId == item.id?'active':''" @click="chooseColorTableNav(item.id)" v-for="item in colorTableList" :key="item.id"><span>{{item.name}}</span>({{item.id_list.length}})</div>
        </div> -->
        <div>
            <div class="list">
                <label :for="item.id" v-for="item in list" :key="item.id">
                    <img :src="item.picture[0]+'?x-oss-process=image/resize,m_fill,h_50,w_50'" alt="">
                    <p>{{item.name}}</p>
                    <!-- <input type="checkbox" name="" :value="item.s_color_id" v-model="checkedIds" :id="item.s_color_id"> -->
                    <input type="checkbox" name="" :value="item.id" v-model="pageCheckedIds[page - 1]" :id="item.id">
                </label>
            </div>
            <div class="next_pre">
                <el-button @click="previousPage" v-show="page > 1">上一页</el-button>
                <el-button @click="nextPage" v-show="(allPage - page) > 0">下一页</el-button>
            </div>
        </div>
        
        <div class="co_btn">
            <label for="checked"><input type="checkbox" id="checked" v-model="checkAll" @click="checkAllBox"><span style="cursor: pointer;">全选</span></label>
            <el-button @click="chooseColor">确认</el-button>
        </div>
    </div>
</template>
<script>
export default {
    props:['color_ids'],
    data(){
        return{
            colorTableId:0, //颜色分类id
            colorTableList:[],
            checkAll:false,
            list:[],
            checkedIds:[],
            saveList:[],
            page: 1,
            allPage:1,
            total:0,
            pageCheckedIds:[],
            
        }
    },
	computed:{
		userInfo(){
			return this.$store.state.userInfo
		},
		supplier_id(){
		  if(this.$store.state.supplierInfo){
		    return this.$store.state.supplierInfo.id
		  }else{
		    return 0
		  }
		},
    },
    watch:{
        'pageCheckedIds':function(){
            let len = this.list.length
            let pagelen = this.pageCheckedIds[this.page - 1].length
            if(pagelen == len){
                this.checkAll = true
            }else{
                this.checkAll = false
            }
        },
    },
    methods:{
        getColorIds(ids){
            this.color_ids = ids
        },
        checkAllBox(){
            let len = this.list.length
            let pagelen = this.pageCheckedIds[this.page - 1].length
            if(pagelen == len){
                this.pageCheckedIds[this.page - 1] = []
            }else{
                this.pageCheckedIds[this.page - 1] = []
                this.list.forEach(item => {
                    this.pageCheckedIds[this.page - 1].push(item.id)
                })
            }
        },
        chooseColor(){
            let checkedId = []
            this.pageCheckedIds.forEach(item => {
                checkedId = checkedId.concat(item)
            })
            let newObj = {}
            let peon = this.saveList.reduce((cur,next) => {
                newObj[next.id] ? "" : newObj[next.id] = true && cur.push(next);
                return cur;
            },[])
            let newList = peon.filter(item => {
                return checkedId.indexOf(item.id) != -1
            })
            this.$emit('chooseColor',newList)
        },
        nextPage(){
            if(this.color_ids.length){
                // this.axios.post('https://ggtools.thinkerx.com/erp/get_supplier_color_exist',{
                //     uid:this.userInfo.id,
                //     supplier_id:this.supplier_id,
                //     page:++this.page,
                //     limit:20,
                //     exist_color_ids:this.color_ids
                // }).then(res => {
                //     let list = res.data.data.res
                //     if(list && list.length){
                //         list.forEach(item => {
                //             this.saveList.push(item)
                //         })
                //         this.list = list
                //     }
                //     this.setCheckedAll()
                // })
                this.$post("/py/erp/get_supplier_color_exist",{
                    uid:this.userInfo.id,
                    supplier_id:this.supplier_id,
                    page:++this.page,
                    limit:20,
                    exist_color_ids:this.color_ids
                },res => {
                    let list = res.data.res
                    if(list && list.length){
                        list.forEach(item => {
                            this.saveList.push(item)
                        })
                        this.list = list
                    }
                    this.setCheckedAll()
                })
            }else{
                // this.axios.get('https://ggtools.thinkerx.com/erp/get_supplier_color',{
                //     params:{
                //         uid:this.userInfo.id,
                //         supplier_id:this.supplier_id,
                //         page:++this.page,
                //         limit:20
                //     }
                // }).then(res => {
                //     let list = res.data.data.res
                //     if(list && list.length){
                //         list.forEach(item => {
                //             this.saveList.push(item)
                //         })
                //         this.list = list
                //     }
                //     this.setCheckedAll()
                // })
                this.$get("/py/erp/get_supplier_color",{
                    uid:this.userInfo.id,
                    supplier_id:this.supplier_id,
                    page:++this.page,
                    limit:20
                },res => {  
                    let list = res.data.res
                    if(list && list.length){
                        list.forEach(item => {
                            this.saveList.push(item)
                        })
                        this.list = list
                    }
                    this.setCheckedAll()
                })
            }
            
        },
        previousPage(){
            if(this.color_ids.length){
                this.$post("/py/erp/get_supplier_color_exist",{
                    uid:this.userInfo.id,
                    supplier_id:this.supplier_id,
                    page:--this.page,
                    limit:20,
                    exist_color_ids:this.color_ids
                },res => {
                    let list = res.data.res
                    if(list && list.length){
                        this.list = list
                    }
                    this.setCheckedAll()
                })
            }else{
                this.$get("/py/erp/get_supplier_color",{
                    uid:this.userInfo.id,
                    supplier_id:this.supplier_id,
                    page:--this.page,
                    limit:20
                },res => {  
                    let list = res.data.res
                    if(list && list.length){
                        this.list = list
                    }
                    this.setCheckedAll()
                })
            }
            
        },
        // 切换页码时修改全选状态
        setCheckedAll(){
            let len = this.list.length
            let pagelen = this.pageCheckedIds[this.page - 1].length
            if(pagelen == len){
                this.checkAll = true
            }else{
                this.checkAll = false
            }
        },
        getColorTableList(){
            this.$post('/py/erp/get_supplier_color_exist_table',{
                supplier_id: this.supplier_id,
                uid: this.userInfo.id,
                exist_color_ids:this.color_ids
            },res => {
                // this.colorTableList = res.data
                console.log(this.colorTableList)
            })
        },
        chooseColorTableNav(tableId){
            this.colorTableId = tableId
            // this.getList()
            
        },
        getList(){
            if(this.color_ids.length){
                this.getColorTableList()
                this.$post("/py/erp/get_supplier_color_exist",{
                    uid:this.userInfo.id,
                    supplier_id:this.supplier_id,
                    page:1,
                    limit:20,
                    exist_color_ids:this.color_ids
                },res => {
                    let list = res.data.res
                    if(list && list.length){
                        this.list = list
                        this.saveList = list
                    }else{
                        this.$message.warning('请先在基础数据中设置色卡数据')
                    }
                    this.total = res.data.total
                    this.allPage = Math.ceil(this.total/20)
                    for(let i=0;i<this.allPage;i++){
                        this.pageCheckedIds[i] = []
                    }
                })
            }else{
                this.$get("/py/erp/get_supplier_color",{
                    uid:this.userInfo.id,
                    supplier_id:this.supplier_id,
                    page:1,
                    limit:20
                },res => {  
                    let list = res.data.res
                    if(list && list.length){
                        this.list = list
                        this.saveList = list
                    }else{
                        this.$message.warning('请先在基础数据中设置色卡数据')
                    }
                    this.total = res.data.total
                    this.allPage = Math.ceil(this.total/20)
                    for(let i=0;i<this.allPage;i++){
                        this.pageCheckedIds[i] = []
                    }
                })
            }
        }
    },
    mounted(){
        this.getList()
    }
}
</script>
